<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    兴东站<br>
站点介绍<br>
兴东站位于创业二路和留仙二路交汇处，车站所在位置是宝安旧城繁华地带，车站西南侧为天辉进出入口公司、宝安饮食服务公司等商住建筑群；东南侧为深圳市新福装饰材料市场；西北侧为新日佳百货等商住建筑群。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:12	23:53	5号线	3分钟	5分25秒<br>
黄贝岭	06:13	23:28	5号线	3分钟	5分25秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:03	23:52	5号线	4分钟	6分钟<br>
黄贝岭	06:23	23:28	5号线	4分钟	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:03	00:52	5号线	4分钟	6分钟<br>
黄贝岭	06:23	00:28	5号线	4分钟	6分钟<br><br>

站点出口信息<br>
A出入口:<br>
留仙二路西侧(南)、 创业二路南侧（西）、 69区中粮工业园<br><br>
B出入口:<br>
创业二路南侧、创业二路<br><br>
C出入口:<br>
扬田路, 扬田大厦、 创业二村<br><br>
D出入口:<br>
留仙二路西侧（北）、创业二路北侧（西）、 创业一村<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 兴东地铁站<br>
B631<br><br>
B出入口:<br>
公交站名： 兴东地铁站<br>
605、613、M131、M182、M197、M395、M518、M560、高快巴士33号、高峰专线56<br><br>
C出入口:<br>
公交站名： 兴东地铁站<br>
M206、M376、M377、M378、M379、M382、M393、M395、M518、M560、M182、605、613、M131、M197、高快巴士33号、M338、高峰专线56<br><br>
D出入口:<br>
公交站名： 中粮创芯公园北（原
新福市场1）<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


